import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import { createPayment } from "../_actions";

class AddBankDepositModal extends React.Component {
    _validate = (values) => {
        const errors = { paymentTransaction: {} };
        errors.paymentTransaction.accountId = FormUtils.validators.required(values.paymentTransaction.accountId);
        errors.paymentTransaction.amount = FormUtils.validators.required(values.paymentTransaction.amount);
        errors.paymentTransaction.amount = errors.paymentTransaction.amount || FormUtils.validators.range(-100000, 100000)(values.paymentTransaction.amount);
        errors.paymentTransaction.amount = errors.paymentTransaction.amount || (values.paymentTransaction.amount === 0 ? "Value must be greater or less than 0" : undefined);
        errors.paymentTransaction.reference = FormUtils.validators.required(values.paymentTransaction.reference);
        errors.paymentTransaction.reference = errors.paymentTransaction.reference || FormUtils.validators.maxLength(50)(values.paymentTransaction.reference);
        return errors;
    };

    _save = (values) => {
        const { viewModel = {} } = this.props;
        this.props.createPayment(values.paymentTransaction, viewModel.yearMonth, viewModel.accountId);
    };

    render() {
        const { viewModel = {}, online } = this.props;

        return (
            <Form validate={this._validate} initialValues={viewModel} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded, submitting }) => {
                    return (
                        <Modal title="Add bank deposit for org" skinny>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="organisationName" label="Organisation" component={InputPack} disabled={true} />
                                                <Field name="paymentTransaction.amount" label="Amount" placeholder="Payment amount" dataWidth="50" component={InputPack} format={FormUtils.formatters.formatDecimal(2)} formatOnBlur required={true} />
                                                <Field name="paymentTransaction.reference" label="Reference" placeholder="Payment reference" component={InputPack} required={true} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={submitSucceeded || submitting || !online}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withAppContext,
    withState((state, ownProps) => {
        return {
            ...ownProps,
            accounts: state.admin.allAccounts,
        };
    }),
    withActions({ createPayment })
)(AddBankDepositModal);
